import React, { useCallback, useEffect } from 'react';
import styles from './ImageModal.module.css';

const ImageModal = ({ isOpen, onClose, imageUrl, imageAlt, imageLabel }) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    } else {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={handleBackdropClick}>
      <div className={styles.modalContent}>
        <button className={styles.closeButton} onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
        
        <div className={styles.imageContainer}>
          <img
            src={imageUrl}
            alt={imageAlt || 'Action log image'}
            className={styles.fullSizeImage}
          />
          {imageLabel && (
            <div className={styles.imageLabel}>
              {imageLabel}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
